import AdminAssignmentsService from '../api/AdminAssignmentsService';
import type { PaginationState } from '@tanstack/react-table';
import { useQuery } from '@tanstack/react-query';
import { useWorkflowSearchStore } from '@/client/components/admin/assignments/state/workflowSearchStore';

export const useListAssignmentRecipients = (
  pagination: PaginationState,
  id: string | undefined,
  isInstance: boolean,
) => {
  const { selectedItems, selectedFilterOption, selectedCompletionStatus } =
    useWorkflowSearchStore();

  const payload = {
    page: pagination.pageIndex,
    pageSize: pagination.pageSize,
    ...(isInstance ? { groupId: { eq: id } } : { workflowId: { eq: id } }),
    ...(selectedFilterOption.value === 'users' &&
      selectedItems.length > 0 && {
        assigneeId: {
          in: selectedItems.map((item) => item.id),
        },
      }),
    ...(selectedFilterOption.value === 'content' &&
      selectedItems.length > 0 && {
        contentId: {
          in: selectedItems.map((item) => item.id),
        },
      }),
    ...(selectedCompletionStatus?.value && {
      completionStatus: {
        eq: selectedCompletionStatus.value,
      },
    }),
  };

  return useQuery({
    enabled: !!id,
    queryKey: [
      'listAssignmentRecipients',
      {
        payload,
      },
    ],
    queryFn: () => AdminAssignmentsService.listAssignmentRecipients(payload),
    keepPreviousData: true,
  });
};
